module.exports = {"audiences":["newAndNoTeamsAndNoBoards"],"autoTrack":true,"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-10-31"},"variations":[{"name":"guidedTour","weight":0,"values":{}},{"name":"simplifiedView","weight":0.33,"values":{}},{"name":"helpOverlay","weight":0,"values":{}},{"name":"inlineInspirations","weight":0.33,"values":{}},{"name":"madLibsNoSkip","weight":0.33,"values":{}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/onboarding.json
// module id = c7Lg
// module chunks = 12